import { api, unwrap, toPaginated, cleanParams } from "../lib/axios";
import type { ApiEnvelope, ListParams, PaginatedResult } from "../types/api";
import type { SOSAlert } from "../types/domain";

export interface SosListParams extends ListParams {
  status?: string;
}

export const sosApi = {
  async list(params: SosListParams): Promise<PaginatedResult<SOSAlert>> {
    const res = await api.get<ApiEnvelope<unknown>>("/sos", {
      params: cleanParams(params),
    });
    return toPaginated<SOSAlert>(res, "sosAlerts");
  },

  async stats(): Promise<Record<string, unknown>> {
    const res = await api.get<ApiEnvelope<Record<string, unknown>>>(
      "/sos/stats",
    );
    return unwrap(res);
  },

  async get(id: string): Promise<SOSAlert> {
    const res = await api.get<ApiEnvelope<SOSAlert>>(`/sos/${id}`);
    return unwrap(res);
  },

  async process(
    id: string,
    action: "notify" | "escalate" | "resolve",
  ): Promise<void> {
    await api.post("/sos/process", { sosId: id, action });
  },
};
